import React from "react";
import { Box, Container } from "@mui/material";

function Blog(props) {
    return (
        <Container
            sx={{
                height: "100%",
                width: "100%",
                display: "flex",
                justifyContent: "center",
            }}>
            <Box>Coming Soon</Box>
        </Container>
    );
}

export default Blog;
